import { useLanguage } from "@/contexts/LanguageContext";

const langs = [
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
  { code: "fr", label: "FR" },
  { code: "ht", label: "HT" },
];

export default function LanguageToggle({ variant = "default" }) {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-0.5" data-testid="language-toggle">
      {langs.map((l, i) => (
        <span key={l.code} className="flex items-center">
          <button
            data-testid={`lang-toggle-${l.code}`}
            onClick={() => setLanguage(l.code)}
            className={`px-2 py-1 text-xs font-bold tracking-[0.15em] uppercase transition-all duration-200
              ${language === l.code
                ? variant === "landing"
                  ? "text-white bg-[#002FA7]"
                  : "text-white bg-[#0A0A0A]"
                : variant === "landing"
                  ? "text-white/70 hover:text-white"
                  : "text-[#9CA3AF] hover:text-[#0A0A0A]"
              }`}
          >
            {l.label}
          </button>
          {i < langs.length - 1 && (
            <span className={`text-xs mx-0.5 ${variant === "landing" ? "text-white/30" : "text-[#E5E7EB]"}`}>|</span>
          )}
        </span>
      ))}
    </div>
  );
}
